import { useDispatch } from 'react-redux';
import OfferModal from '../../../../containers/OffersPage/Components/OfferModal';
import { OpportunitiesTable } from './Components/OpportunitiesTable';

import './index.scss';

export const Opportunities = () => {
  const dispatch = useDispatch();
  return (
    <>
      <OpportunitiesTable dispatch={dispatch} />
      <OfferModal type="opportunities" />
    </>
  );
};
